import React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

import { REPORT_STATUS } from "@constants"
import { MULTIPLE_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import { useReportMultipleList } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportListTableCustomToolbarSelect({ selectedData, setSelectedRows }) {
	const {
		handleClickMultipleOption,
		handlePerformMultipleExecutions,
		handleStopMultipleExecutions,
		handleMultipleClone,
		handleClickMultipleDelete,
		handleClickMultipleDisable,
		handleClickMultipleEnable
	} = useReportMultipleList(selectedData, setSelectedRows)

	return <Box sx={{ mr: 2 }}>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-sites"
			icon="globe-pointer"
			tooltip="Edit Sites for Multiple Reports"
			onClick={() => handleClickMultipleOption(MULTIPLE_OPTIONS.SITES)}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-pickups"
			icon="calendars"
			tooltip="Edit Pick ups for Multiple Reports"
			onClick={() => handleClickMultipleOption(MULTIPLE_OPTIONS.DATES)}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-emails"
			icon="envelopes"
			tooltip="Edit Emails for Multiple Reports"
			onClick={() => handleClickMultipleOption(MULTIPLE_OPTIONS.EMAILS)}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-frequency"
			icon="calendar-clock"
			tooltip="Edit Frequency for Multiple Reports"
			onClick={() => handleClickMultipleOption(MULTIPLE_OPTIONS.FREQUENCY)}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-execution-dates"
			icon="calendar-lines"
			tooltip="Edit Execution Date Range for Multiple Reports"
			onClick={() => handleClickMultipleOption(MULTIPLE_OPTIONS.EXECUTION_DATES)}
		/>
		{selectedData.every(a => a?.enabled) && <ButtonIconSeeker
			data-tour-id="tour-multi-btn-perform"
			icon="gears"
			tooltip="Perform multiple executions"
			onClick={handlePerformMultipleExecutions}
		/>}
		{selectedData.every(a => a?.statusLastExecution === REPORT_STATUS.RUNNING && a?.enabled) && <ButtonIconSeeker
			data-tour-id="tour-multi-btn-stop"
			icon="circle-stop"
			iconWeight="light"
			tooltip="Stop multiple executions"
			onClick={handleStopMultipleExecutions}
		/>}
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-copy"
			icon="copy"
			tooltip="Copy Multiple Reports"
			onClick={handleMultipleClone}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-delete"
			icon="trash"
			tooltip="Delete Multiple Reports"
			onClick={handleClickMultipleDelete}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-disable"
			icon="toggle-off"
			tooltip="Disable Multiple Reports"
			onClick={handleClickMultipleDisable}
		/>
		<ButtonIconSeeker
			data-tour-id="tour-multi-btn-enable"
			icon="toggle-on"
			tooltip="Enable Multiple Reports"
			onClick={handleClickMultipleEnable}
		/>
	</Box>
}